import Listening from "../components/listening";
import Introduction from "../components/introduction";
import Projects from "../components/projects";
import HomeAMA from "../components/homeama";
import RecentPosts from "../components/recentposts";
import Layout from "../components/layout";

function Home() {
  return (
    <div className="flex-grow bg-slate-900 text-slate-200">

      <Listening />

      {/* Introduction - block centered, text left-aligned */}
      <Layout className="py-12">
        <div className="flex flex-col items-center">
          <div className="w-full md:w-3/4">
            <Introduction />
          </div>
        </div>
      </Layout>

      {/* Résumé button - centered */}
      <div className="flex justify-center py-6">
        <a
          href="/pdfs/anand-krishna-resume.pdf"
          rel="noopener noreferrer"
          target="_blank"
          className="inline-block border-2 border-teal-300 p-2 font-mono text-teal-300 shadow-teal-300 shadow-md hover:shadow-sm hover:shadow-teal-300"
        >
          Résumé
        </a>
      </div>

      <Layout className="py-4">
        <HomeAMA />
      </Layout>

      <Layout className="py-10">
        <Projects />
      </Layout>

      <Layout className="py-10">
        <RecentPosts />
      </Layout>

    </div>
  );
}

export default Home;